import axios from 'axios'

import { ServerResponse } from '@/shared/types/common'

//Текст из errors[0] ответа или fallback
export const getAxiosErrorMessage = (error: unknown, fallback: string) => {
	if (!axios.isAxiosError(error)) return fallback

	const data = error.response?.data as ServerResponse<unknown> | undefined
	return data?.errors?.[0]?.message ?? fallback
}
